import TextEditor from './TextEditor';
import { exporter, styles } from './customStyles';

export default TextEditor;
export { exporter, styles };
